import { FC } from "react";
import { Check, Clear } from "@mui/icons-material";

export interface CheckLabelProps {
  isChecked: boolean;
}

const CheckLabel: FC<CheckLabelProps> = (props) => {
  const { isChecked } = props;
  return isChecked ? <Check color="success" /> : <Clear color="disabled" />;
};

export default CheckLabel;
